import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Check, Times } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { selectWork } from '../../Api/selectors';
import { deleteVehicleProperty, setVehicleProperties, setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class SetActionStateButtonCustomComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  render() {
    return (
      <Container>
        <HBox vCenter left>
          {this.props.loading ? (
            <Loader small />
          ) : (
            <Button small disabled={this.props.disabled} primary={this.props.active} onClick={() => this.props.apply()}>
              {this.props.setOn ? <Check /> : this.props.setOff ? <Times /> : ''}
            </Button>
          )}
        </HBox>
      </Container>
    );
  }
}

SetActionStateButtonCustomComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    apply() {
      let update = [];
      //let remove = [];
      let arr = _.map(ownProps.properties, (value, name) => {
        if (value === null) dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
        else
          update.push({
            propertyName: name,
            propertyValue: value,
          });
      });
      dispatch(setVehicleProperties(ownProps.vehicle.id, update));

      //deleteVehicleProperty
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SetActionStateButtonCustom = compose(
  withConnect,
  withRouter,
)(SetActionStateButtonCustomComp);
